function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "31.1436262%",
  y1: "24.1596461%",
  x2: "72.34242%",
  y2: "80.6164263%",
  id: "linearGradient-1-chatWithUsIconMobile"
}, React.createElement("stop", {
  stopColor: "#6EC18A",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#0E89CA",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "21.3173604%",
  y1: "24.1596461%",
  x2: "83.9853034%",
  y2: "80.6164263%",
  id: "linearGradient-2-chatWithUsIconMobile"
}, React.createElement("stop", {
  stopColor: "#6EC18A",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#0E89CA",
  offset: "100%"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-chatWithUsIconMobile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "09-mobile-UI-chatWithUsIconMobile",
  transform: "translate(-205.000000, -10.000000)"
}, React.createElement("g", {
  id: "Group-12-chatWithUsIconMobile",
  transform: "translate(205.000000, 10.000000)"
}, React.createElement("g", {
  id: "Group-7-chatWithUsIconMobile"
}, React.createElement("g", {
  id: "Group-3-chatWithUsIconMobile"
}, React.createElement("path", {
  d: "M6.05063206,32.8408403 C1.6570093,30.3531345 8.66107729,8.99999976 20.6841666,8.99999976 C32.7052768,8.99999976 32.7052768,36.4235284 20.6841666,36.4235284 C17.7115443,36.4235284 14.8715224,36.039599 12.2967012,35.3638049 L2.69999993,42.2999989 L6.05063206,32.8408403 Z",
  id: "Stroke-1-Copy-chatWithUsIconMobile",
  stroke: "url(#linearGradient-1-chatWithUsIconMobile)",
  strokeWidth: 0.5,
  fill: "url(#linearGradient-1-chatWithUsIconMobile)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("circle", {
  id: "Oval-chatWithUsIconMobile",
  fill: "url(#linearGradient-2-chatWithUsIconMobile)",
  fillRule: "nonzero",
  cx: 20.2499995,
  cy: 20.2499995,
  r: 20.2499995
}), React.createElement("path", {
  d: "M14.2698284,27.2765217 L15.2999996,24.2141469 L12.9199489,17.1541809 C12.6890484,16.5673786 12.1384397,16.1822895 11.5345462,16.2006271 L11.3924536,16.2006271 C10.3445208,16.2006271 9.61629636,17.3008815 10.007051,18.3094481 L14.2343052,27.8999993 C14.1810205,27.6982859 14.1987821,27.4965726 14.2698284,27.2765217 Z",
  id: "Path-chatWithUsIconMobile",
  fill: "#FFFFFF"
}), React.createElement("path", {
  d: "M20.1094741,16.2002253 L19.9666622,16.2002253 C19.3597118,16.2002253 18.8063159,16.584725 18.5742466,17.1706291 L18.5206922,17.2987957 L16.1999996,24.2014792 L17.2353855,27.2591666 C17.3246429,27.4788806 17.3246429,27.6985947 17.28894,27.8999993 L20.0380681,21.6198389 L21.4840382,18.3058185 C21.8946222,17.2804862 21.1627115,16.1819158 20.1094741,16.2002253 Z",
  id: "Path-chatWithUsIconMobile",
  fill: "#FFFFFF"
}), React.createElement("path", {
  d: "M17.0032684,27.3425094 L15.7476326,24.2999994 L14.4919967,27.3425094 C14.3837523,27.5611329 14.3837523,27.7797563 14.42705,27.9619426 L14.5136456,28.1259102 C14.6868368,28.5085013 15.1198146,28.763562 15.5960903,28.7999994 C15.6177392,28.7999994 15.6177392,28.7999994 15.6393881,28.7999994 C15.661037,28.7999994 15.6826859,28.7999994 15.7043348,28.7999994 L15.7909304,28.7999994 C15.8125792,28.7999994 15.8342281,28.7999994 15.855877,28.7999994 C15.8775259,28.7999994 15.8775259,28.7999994 15.8991748,28.7999994 C16.3754505,28.763562 16.7867795,28.5085013 16.9599706,28.1259102 L17.0465662,27.9619426 C17.1331618,27.7615377 17.1115129,27.5429143 17.0032684,27.3425094 Z",
  id: "Path-chatWithUsIconMobile",
  fill: "#FFFFFF"
}), React.createElement("circle", {
  id: "Oval-chatWithUsIconMobile",
  fill: "#FFFFFF",
  cx: 21.5999994,
  cy: 13.4999996,
  r: 1.79999995
}), React.createElement("path", {
  d: "M27.9094745,16.0002258 L27.7666626,16.0002258 C27.1597123,16.0002258 26.6063163,16.3847254 26.3742471,16.9706296 L26.3206926,17.0987961 L24,24.0014796 L25.0353859,27.059167 C25.1246434,27.2788811 25.1246434,27.4985951 25.0889404,27.6999997 L27.8380686,21.4198394 L29.2840386,18.1058189 C29.6946227,17.0804866 28.9627119,15.9819163 27.9094745,16.0002258 Z",
  id: "Path-chatWithUsIconMobile",
  fill: "#FFFFFF"
}), React.createElement("circle", {
  id: "Oval-chatWithUsIconMobile",
  fill: "#FFFFFF",
  cx: 29.6999992,
  cy: 13.4999996,
  r: 1.79999995
}), React.createElement("path", {
  d: "M22.6211981,27.0775298 L23.5999999,23.9838763 C22.753917,21.3162949 21.6092165,17.7595197 21.3769585,17 C21.4599078,17.3149228 21.4599078,17.6668954 21.3437788,18.0188679 L20,21.3718695 L22.6046082,27.7999997 C22.5382488,27.5777013 22.5382488,27.3183531 22.6211981,27.0775298 Z",
  id: "Path-chatWithUsIconMobile",
  fill: "#FFFFFF"
})), React.createElement("path", {
  d: "M25.1675961,27.4882584 L23.848275,24.2999994 L22.5927919,27.3060722 C22.5076744,27.4882584 22.4863951,27.6704446 22.5076744,27.8526308 C22.5076744,27.9072867 22.5289538,27.9801612 22.5502332,28.0530357 C22.5502332,28.0530357 22.8907032,28.7999994 23.8057162,28.7999994 C23.8908337,28.7999994 23.9972306,28.7999994 24.01851,28.7999994 C24.5079355,28.763562 24.9122436,28.5085013 25.103758,28.1076916 C25.0824786,28.1076916 25.273993,27.7068819 25.1675961,27.4882584 Z",
  id: "Path-chatWithUsIconMobile",
  fill: "#FFFFFF"
})))));

var SvgChatWithUsIconMobile = function SvgChatWithUsIconMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "41px",
    height: "43px",
    viewBox: "0 0 41 43",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChatWithUsIconMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chatWithUsIconMobile.575bb788.svg";
export { ForwardRef as ReactComponent };